import { NgModule } from '@angular/core';
import { FiAppearanceTrashBinComponent } from './trash-bin.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { DndModule } from 'ngx-drag-drop';

@NgModule({
    imports: [FiAppTextSharedModule, DndModule],
    declarations: [FiAppearanceTrashBinComponent],
    exports: [FiAppearanceTrashBinComponent],
})
export class FiAppearanceTrashBinModule {}
